import styled from "styled-components";

export const MapContainer = styled.div`
    width: 100%;
    padding: 16px;
    background-color: #f9fafb;
`;

export const MapHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 14px;
`;

export const MapTitle = styled.h2`
    margin: 0;
    color: #111827;
    font-size: 22px;
    font-weight: 700;
`;

export const FilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 140px;
`;

export const FilterLabel = styled.label`
    color: #374151;
    font-size: 13px;
    font-weight: 600;
`;

export const FilterSelect = styled.select`
    height: 38px;
    padding: 6px 10px;
    border: 1px solid #d1d5db;
    border-radius: 7px;
    background-color: #ffffff;
    color: #111827;
    font-size: 14px;
    outline: none;

    &:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.18);
    }
`;

//Estadísticas superiores
export const StatisticsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    margin-top: 6px;
`;

export const StatisticItem = styled.div`
    min-height: 76px;
    padding: 11px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);

    small {
        display: block;
        margin-top: 4px;
        color: #6b7280;
        font-size: 11px;
        line-height: 1.3;
    }
`;

export const StatisticLabel = styled.div`
    margin-bottom: 5px;
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
`;

export const StatisticValue = styled.div`
    color: #111827;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.1;
`;

//Contenedor del mapa
export const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    background-color: #ffffff;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);

    .maplibregl-popup {
        z-index: 30;
    }

    .maplibregl-popup-content {
        padding: 12px;
        border-radius: 10px;
        box-shadow:
            0 10px 30px
            rgba(15, 23, 42, 0.24);
    }

    .maplibregl-popup-close-button {
        padding: 5px 8px;
        color: #374151;
        font-size: 18px;
    }

    .maplibregl-ctrl-group {
        border-radius: 8px;
        overflow: hidden;
    }
`;

//Popup analítico
export const PopupContent = styled.div`
    min-width: 160px;
    max-width: 230px;
    padding: 4px;
    color: #111827;
`;

export const PopupTitle = styled.h3`
    margin: 0 0 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e7eb;
    color: #111827;
    font-size: 16px;
    font-weight: 800;
`;

export const PopupRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 4px 0;
    color: #111827;
    font-size: 13px;
    line-height: 1.25;

    span:last-child {
        max-width: 160px;
        text-align: right;
        font-weight: 600;
    }
`;

export const PopupLabel = styled.span`
    color: #4b5563;
    font-weight: 700;
`;

//Leyenda flotante
export const FloatingLegend = styled.div`
    position: absolute;
    left: 16px;
    bottom: 16px;
    z-index: 10;
    min-width: 190px;
    padding: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.94);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
    backdrop-filter: blur(4px);
`;

export const LegendTitle = styled.div`
    margin-bottom: 8px;
    color: #111827;
    font-size: 13px;
    font-weight: 800;
`;

export const LegendContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    color: #374151;
    font-size: 13px;
    font-weight: 600;
`;

export const LegendColor = styled.span`
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    border: 1px solid rgba(17, 24, 39, 0.18);
    border-radius: 999px;
    background-color: ${({ $color }) => $color || "#d1d5db"};
`;

//Mensajes de carga y error
export const LoadingMessage = styled.div`
    margin: 12px 0;
    padding: 10px 12px;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    background-color: #eff6ff;
    color: #1d4ed8;
    font-size: 14px;
    font-weight: 600;
`;

export const ErrorMessage = styled.div`
    margin: 12px 0;
    padding: 10px 12px;
    border: 1px solid #fecaca;
    border-radius: 8px;
    background-color: #fef2f2;
    color: #b91c1c;
    font-size: 14px;
    font-weight: 600;
`;

//Botón para navegación
export const ActionButton = styled.button`
    height: 38px;
    padding: 0 14px;
    border: none;
    border-radius: 8px;
    background-color: #25784e;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;

    &:hover {
        background-color: #1f2937;
    }

    &:disabled {
        background-color: #9ca3af;
        cursor: not-allowed;
    }
`;

export const FarmsSplitContent = styled.div`
    display: grid;
    grid-template-columns: 100% 0%;
    gap: 16px;
    width: 100%;
    margin-top: 16px;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
    }
`;

export const FarmsLeftPanel = styled.div`
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 14px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
    height: 720px;
    overflow: auto;
    min-width: 0;
`;

export const FarmsRightPanel = styled.div`
    min-width: 0;
`;

export const FarmsTableTitle = styled.h3`
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
`;

export const FarmsDynamicTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #f9fafb;
        color: #374151;
        font-weight: 700;
        padding: 2px;
        border: 1px solid #e5e7eb;
        text-align: center;
        white-space: nowrap;
    }

    td {
        padding: 6px 6px;
        border: 1px solid #e5e7eb;
        color: #374151;
        vertical-align: middle;
        text-align: center;
    }

    tbody tr {
        cursor: pointer;
    }

    tbody tr:hover {
        background: #f3f4f6;
    }

    tfoot td {
        position: sticky;
        bottom: 0;
        z-index: 2;
        background: #f9fafb;
        color: #374151;
        font-weight: 800;
        border: 1px solid #e5e7eb;
    }
`;

export const FarmNameCell = styled.td`
    text-align: left !important;
    font-weight: 700;
    color: #111827 !important;
    min-width: 170px;
`;

export const FarmCycleCell = styled.td`
    background: ${({ $color }) => $color || "#f3f4f6"};
    color: ${({ $textColor }) => $textColor || "#111827"} !important;
    font-weight: 700;
`;

export const FarmStatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    background: ${({ $color }) => $color || "#e5e7eb"};
    color: #111827;
`;

export const DateRangeWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const DateRangeButton = styled.button`
    width: 100%;
    min-width: 280px;
    height: 40px;
    padding: 0 14px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    background: #ffffff;
    color: #111827;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;

    &:hover {
        border-color: #f0a808;
        box-shadow: 0 0 0 3px rgba(240, 168, 8, 0.18);
    }
`;

export const DateRangeDropdown = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 50;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    padding: 14px;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);

    .rdp {
        --rdp-accent-color: #f0a808;
        --rdp-accent-background-color: rgba(240, 168, 8, 0.18);
        --rdp-day_button-border-radius: 999px;
        margin: 0;
    }

    .rdp-range_middle {
        background-color: rgba(240, 168, 8, 0.18);
    }

    .rdp-range_start .rdp-day_button,
    .rdp-range_end .rdp-day_button {
        background-color: #f0a808;
        color: #ffffff;
    }

        .rdp-week_number {
        color: #6b7280;
        font-size: 12px;
        font-weight: 700;
    }

    .rdp-weeknumber {
        color: #6b7280;
        font-size: 12px;
        font-weight: 700;
    }

    .rdp-caption_label {
        font-weight: 800;
        color: #111827;
    }
`;

export const DateRangeActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 12px;
    margin-top: 10px;
    border-top: 1px solid #e5e7eb;
`;

export const FarmTransportCell = styled.td`
    background: ${({ $active }) =>
        $active ? "#16a34a" : "transparent"};

    color: ${({ $active }) =>
        $active ? "#ffffff" : "#374151"} !important;

    font-weight: ${({ $active }) =>
        $active ? "800" : "500"};

    text-align: center;
`;